import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    windows_download_url: "",
    android_download_url: "",
    stat_students: "17,000+",
    stat_youtube_views: "10M+",
    stat_watch_time: "100K+",
    telegram_username: "AducationOfficial",
    support_email: "support@aducation.in",
    youtube_url: "",
    instagram_url: "",
    whatsapp_number: "",
    whatsapp_message: "Hi Aducation, I have a question about your courses.",
    primary_chat_channel: "telegram",
    site_url: "",
    ga4_measurement_id: "",
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("settings load failed", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
